import { render } from "./notification.vue?vue&type=template&id=703846e8&scoped=true"
import script from "./notification.vue?vue&type=script&lang=js"
export * from "./notification.vue?vue&type=script&lang=js"

import "./notification.vue?vue&type=style&index=0&id=703846e8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-703846e8"]])

export default __exports__